var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdatePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-63"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.21,157.82a60.61,60.61,0,0,0-8.71-20.95l7.5-9.06-16-16-9.06,7.5A60.69,60.69,0,0,0,206,110.56l-1.1-11.67H182.18l-1.1,11.67a60.56,60.56,0,0,0-20.94,8.71l-9.06-7.5-16,16,7.5,9.06a60.61,60.61,0,0,0-8.71,20.95l-11.68,1.1v22.67l11.68,1.1a60.69,60.69,0,0,0,8.71,20.95L135,212.7l16,16,9.06-7.5a60.37,60.37,0,0,0,20.94,8.71l1.1,11.68h22.68l1.1-11.68a60.5,60.5,0,0,0,20.95-8.71l9.06,7.5,16-16-7.5-9.06a60.69,60.69,0,0,0,8.71-20.95l11.68-1.1V158.92Zm-29,12.43a30.7,30.7,0,1,1-30.7-30.7A30.69,30.69,0,0,1,224.22,170.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.25,266.65,319,275h16.29l.79-8.39a43.58,43.58,0,0,0,15.05-6.25l6.51,5.39,11.53-11.53-5.39-6.51a43.47,43.47,0,0,0,6.25-15.05l8.39-.79V215.62l-8.39-.79a43.47,43.47,0,0,0-6.25-15.05l5.39-6.51-11.53-11.52-6.51,5.39a43.41,43.41,0,0,0-15.05-6.26l-.79-8.39H319l-.79,8.39a43.49,43.49,0,0,0-15.05,6.26l-6.51-5.39-11.52,11.52,5.39,6.51a43.49,43.49,0,0,0-6.26,15.05l-8.39.79v16.29l8.39.79a43.49,43.49,0,0,0,6.26,15.05l-5.39,6.51,11.52,11.53,6.51-5.39A43.66,43.66,0,0,0,318.25,266.65Zm8.94-20.83a22.06,22.06,0,1,1,22.05-22A22.06,22.06,0,0,1,327.19,245.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.51,346.92l.4,4.28h8.31l.41-4.27a22.27,22.27,0,0,0,7.67-3.2l3.32,2.75,5.88-5.87-2.75-3.32a22.22,22.22,0,0,0,3.19-7.68l4.28-.4V320.9l-4.28-.4a22.22,22.22,0,0,0-3.19-7.68l2.75-3.32-5.88-5.88-3.32,2.75a22.25,22.25,0,0,0-7.67-3.19l-.41-4.28h-8.31l-.4,4.28a22.25,22.25,0,0,0-7.67,3.19l-3.32-2.75-5.88,5.88,2.75,3.32a22,22,0,0,0-3.19,7.68l-4.28.4v8.31l4.28.4a22,22,0,0,0,3.19,7.68l-2.75,3.32,5.88,5.87,3.32-2.75A22.06,22.06,0,0,0,110.51,346.92Zm4.56-10.62a11.25,11.25,0,1,1,11.25-11.25A11.25,11.25,0,0,1,115.07,336.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.25,326.16l.33,3.52h6.84l.33-3.52a18.31,18.31,0,0,0,6.32-2.63l2.73,2.27,4.84-4.84-2.27-2.73a18.23,18.23,0,0,0,2.63-6.32l3.52-.33v-6.84l-3.52-.33a18.31,18.31,0,0,0-2.63-6.32l2.27-2.73-4.84-4.84-2.73,2.27a18.31,18.31,0,0,0-6.32-2.63l-.33-3.52h-6.84l-.33,3.52a18.31,18.31,0,0,0-6.32,2.63l-2.73-2.27-4.84,4.84,2.27,2.73a18.31,18.31,0,0,0-2.63,6.32l-3.52.33v6.84l3.52.33a18.23,18.23,0,0,0,2.63,6.32L395.36,321l4.84,4.84,2.73-2.27A18.31,18.31,0,0,0,409.25,326.16Zm3.75-8.74a9.26,9.26,0,1,1,9.26-9.26A9.27,9.27,0,0,1,413,317.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.73,380.75h19.4l.94-10A51.52,51.52,0,0,0,270,363.31l7.75,6.42L291.45,356,285,348.26a51.67,51.67,0,0,0,7.44-17.92l10-.94V310l-10-.94A51.7,51.7,0,0,0,285,291.15l6.41-7.75-13.72-13.72L270,276.09a51.91,51.91,0,0,0-17.91-7.45l-.94-10h-19.4l-.94,10a51.88,51.88,0,0,0-17.92,7.45l-7.75-6.41L191.4,283.4l6.42,7.75a51.52,51.52,0,0,0-7.45,17.91l-10,.94v19.4l10,.94a51.5,51.5,0,0,0,7.45,17.92L191.4,356l13.72,13.72,7.75-6.42a51.5,51.5,0,0,0,17.92,7.45Zm9.7-34.79a26.26,26.26,0,1,1,26.26-26.26A26.26,26.26,0,0,1,241.43,346Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16,345.26l-1-2a13.06,13.06,0,0,0-17.62-5.49l-4.68,2.45a13.08,13.08,0,0,0-5.49,17.63l1,1.95-3.26,1.72,11.75,22.38,34.31-18-11.75-22.39ZM333,362.38l2.05,3.91-2.48,1.31-2.05-3.91a2.72,2.72,0,0,1-2.29-1.43,2.77,2.77,0,1,1,4.9-2.57A2.69,2.69,0,0,1,333,362.38ZM335,348l-17.49,9.18-1-2a7.25,7.25,0,0,1,3.05-9.77l4.67-2.45a7.25,7.25,0,0,1,9.77,3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.31,226.35l.73-2.08A13.08,13.08,0,0,0,93,207.65l-5-1.73A13.07,13.07,0,0,0,71.39,214l-.73,2.09-3.47-1.21-8.3,23.89L95.5,251.45l8.29-23.89Zm-17.38,6.51L81.48,237l-2.65-.92,1.45-4.17a2.71,2.71,0,0,1-.53-2.64A2.77,2.77,0,1,1,85,231.1,2.73,2.73,0,0,1,82.93,232.86Zm11.89-8.41L76.16,218l.72-2.09a7.25,7.25,0,0,1,9.21-4.46l5,1.73a7.24,7.24,0,0,1,4.46,9.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.93,214.67l-2.14-.68A13.31,13.31,0,1,0,414,210.24l-2.13-.68a12.37,12.37,0,0,0-15.54,8l-2.14,6.74,39.64,12.59L436,230.2A12.36,12.36,0,0,0,427.93,214.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.19,93.9l-1.33.56a8.57,8.57,0,1,0-7.34,3.09l-1.33.56a8,8,0,0,0-4.26,10.42l1.76,4.2,24.69-10.38-1.77-4.19A8,8,0,0,0,284.19,93.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5,122l-1.41-.29a8.59,8.59,0,1,0-7.8-1.63l-1.41-.29A8,8,0,0,0,85.46,126l-.93,4.45,26.21,5.46.93-4.45A8,8,0,0,0,105.5,122Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-63"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-63",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.95,
    y: 133.42,
    width: 193.55,
    height: 234.31,
    rx: 7.32,
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.95,
    y: 133.42,
    width: 193.55,
    height: 234.31,
    rx: 7.32,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 277.77,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.9,288.53a3.23,3.23,0,0,1,3.36-3.27,3.13,3.13,0,0,1,2.35.94l-.43.43a2.56,2.56,0,0,0-1.9-.76,2.66,2.66,0,1,0,0,5.32,2.53,2.53,0,0,0,1.9-.77l.43.43a3.13,3.13,0,0,1-2.36.94A3.21,3.21,0,0,1,220.9,288.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.22,289.33a2.46,2.46,0,1,1,2.46,2.45A2.38,2.38,0,0,1,227.22,289.33Zm4.25,0a1.8,1.8,0,1,0-1.79,1.88A1.76,1.76,0,0,0,231.47,289.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.9,288.94v2.8h-.65V289a1.35,1.35,0,0,0-1.45-1.54,1.59,1.59,0,0,0-1.69,1.75v2.53h-.65v-4.83h.62v.89a2,2,0,0,1,1.84-.92A1.85,1.85,0,0,1,237.9,288.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24,284.89a1.55,1.55,0,0,1,1,.3l-.22.49a1.08,1.08,0,0,0-.72-.24c-.55,0-.85.31-.85.91v.56h1.49v.55h-1.47v4.28h-.65v-4.28h-.86v-.55h.86v-.59A1.33,1.33,0,0,1,241.24,284.89Zm3.08.49a.47.47,0,0,1-.48.48.47.47,0,1,1,0-.93A.46.46,0,0,1,244.32,285.38Zm-.81,1.53h.65v4.83h-.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.41,286.88v.63h-.16a1.56,1.56,0,0,0-1.62,1.78v2.46H246v-4.83h.62v.95A1.82,1.82,0,0,1,248.41,286.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,288.94v2.8h-.65V289c0-1-.51-1.54-1.38-1.54a1.56,1.56,0,0,0-1.62,1.75v2.53h-.65V289c0-1-.51-1.54-1.39-1.54a1.57,1.57,0,0,0-1.62,1.75v2.53h-.65v-4.83h.63v.88a2,2,0,0,1,1.77-.91,1.73,1.73,0,0,1,1.71,1,2.1,2.1,0,0,1,1.91-1A1.82,1.82,0,0,1,257.54,288.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.22,285.32v6.42h-.56l-4.13-5.21v5.21h-.68v-6.42h.56l4.14,5.21v-5.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.37,289.53h-4a1.78,1.78,0,0,0,1.9,1.68,1.87,1.87,0,0,0,1.47-.64l.37.43a2.55,2.55,0,0,1-4.39-1.67,2.32,2.32,0,0,1,2.35-2.45,2.3,2.3,0,0,1,2.34,2.45C273.38,289.38,273.37,289.45,273.37,289.53Zm-4-.49h3.42a1.71,1.71,0,0,0-3.42,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.7,286.91l-1.83,4.83h-.61l-1.52-3.95-1.52,3.95h-.62l-1.81-4.83h.62l1.51,4.1,1.55-4.1H278l1.54,4.1,1.53-4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.25,287.52c0,1.37-1,2.19-2.63,2.19H285.9v2h-.68v-6.42h2.4C289.26,285.32,290.25,286.14,290.25,287.52Zm-.68,0c0-1-.68-1.61-2-1.61H285.9v3.21h1.71C288.89,289.12,289.57,288.53,289.57,287.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.17,288.75v3h-.62V291a1.82,1.82,0,0,1-1.66.79c-1.09,0-1.76-.57-1.76-1.4S291.6,289,293,289h1.53v-.29c0-.82-.47-1.27-1.37-1.27a2.48,2.48,0,0,0-1.6.56l-.29-.48a3.06,3.06,0,0,1,2-.65A1.71,1.71,0,0,1,295.17,288.75Zm-.65,1.54v-.79H293c-.94,0-1.24.37-1.24.86s.45.91,1.22.91A1.55,1.55,0,0,0,294.52,290.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.27,291.19l.3-.52a2.83,2.83,0,0,0,1.71.54c.92,0,1.29-.31,1.29-.78,0-1.26-3.12-.27-3.12-2.18,0-.79.68-1.37,1.9-1.37a3.21,3.21,0,0,1,1.71.45l-.28.52a2.53,2.53,0,0,0-1.43-.41c-.87,0-1.25.34-1.25.79,0,1.31,3.13.33,3.13,2.18,0,.83-.74,1.37-2,1.37A3.25,3.25,0,0,1,296.27,291.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.76,291.19l.29-.52a2.89,2.89,0,0,0,1.72.54c.91,0,1.29-.31,1.29-.78,0-1.26-3.13-.27-3.13-2.18,0-.79.68-1.37,1.91-1.37a3.2,3.2,0,0,1,1.7.45l-.28.52a2.5,2.5,0,0,0-1.42-.41c-.87,0-1.26.34-1.26.79,0,1.31,3.13.33,3.13,2.18,0,.83-.73,1.37-2,1.37A3.2,3.2,0,0,1,300.76,291.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,286.91l-1.83,4.83h-.61l-1.52-3.95-1.52,3.95h-.62L305,286.91h.62l1.51,4.1,1.55-4.1h.56l1.54,4.1,1.53-4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.26,289.33a2.45,2.45,0,1,1,2.46,2.45A2.37,2.37,0,0,1,313.26,289.33Zm4.24,0a1.79,1.79,0,1,0-1.78,1.88A1.76,1.76,0,0,0,317.5,289.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.92,286.88v.63h-.15a1.56,1.56,0,0,0-1.62,1.78v2.46h-.66v-4.83h.63v.95A1.82,1.82,0,0,1,321.92,286.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.45,284.93v6.81h-.62v-1a2.08,2.08,0,0,1-1.86,1,2.45,2.45,0,0,1,0-4.9,2.1,2.1,0,0,1,1.83.95v-2.9Zm-.64,4.4a1.79,1.79,0,1,0-1.79,1.88A1.76,1.76,0,0,0,326.81,289.33Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 321.61,
    width: 130.84,
    height: 22.4,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.11,224.8v1.5h2v.35h-2v1.63h-.41v-3.83h2.63v.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.7,226.84a1.47,1.47,0,1,1,1.47,1.47A1.42,1.42,0,0,1,217.7,226.84Zm2.54,0a1.08,1.08,0,1,0-1.07,1.12A1.05,1.05,0,0,0,220.24,226.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.88,225.38v.38h-.09a.93.93,0,0,0-1,1.06v1.47h-.39V225.4h.37V226A1.09,1.09,0,0,1,222.88,225.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.22,225.4v2.53a1.26,1.26,0,0,1-1.44,1.44,2,2,0,0,1-1.34-.44l.2-.3a1.69,1.69,0,0,0,1.13.4c.73,0,1.06-.34,1.06-1.05v-.37a1.29,1.29,0,0,1-1.12.56,1.4,1.4,0,1,1,0-2.79,1.32,1.32,0,0,1,1.14.57v-.55Zm-.38,1.37a1.09,1.09,0,1,0-1.09,1.06A1,1,0,0,0,225.84,226.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227,226.84a1.47,1.47,0,1,1,1.47,1.47A1.42,1.42,0,0,1,227,226.84Zm2.54,0a1.07,1.07,0,1,0-1.07,1.12A1.05,1.05,0,0,0,229.56,226.84Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M232.27,228.11a1,1,0,0,1-.61.2.76.76,0,0,1-.84-.84v-1.74h-.52v-.33h.52v-.63h.39v.63h.87v.33h-.87v1.72c0,.34.17.52.49.52a.69.69,0,0,0,.43-.14Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5,225.76c0,.82-.6,1.31-1.57,1.31h-1v1.21h-.41v-3.83h1.44C236.9,224.45,237.5,224.94,237.5,225.76Zm-.41,0c0-.61-.4-1-1.17-1h-1v1.91h1C236.69,226.71,237.09,226.36,237.09,225.76Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.44,226.5v1.78h-.37v-.45a1.09,1.09,0,0,1-1,.48c-.66,0-1.06-.34-1.06-.84s.29-.82,1.12-.82h.91v-.17a.71.71,0,0,0-.81-.76,1.44,1.44,0,0,0-1,.34l-.18-.29a1.81,1.81,0,0,1,1.17-.39A1,1,0,0,1,240.44,226.5Zm-.39.92v-.48h-.9c-.56,0-.74.22-.74.52s.27.54.73.54A.92.92,0,0,0,240.05,227.42Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.1,228l.18-.3a1.72,1.72,0,0,0,1,.32c.55,0,.77-.19.77-.47,0-.75-1.87-.16-1.87-1.3,0-.47.41-.82,1.14-.82a1.88,1.88,0,0,1,1,.27l-.17.31a1.44,1.44,0,0,0-.85-.25c-.52,0-.75.2-.75.48,0,.78,1.87.19,1.87,1.3,0,.5-.44.82-1.19.82A1.9,1.9,0,0,1,241.1,228Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M243.78,228l.18-.3a1.74,1.74,0,0,0,1,.32c.55,0,.77-.19.77-.47,0-.75-1.86-.16-1.86-1.3,0-.47.4-.82,1.13-.82a1.88,1.88,0,0,1,1,.27l-.17.31a1.44,1.44,0,0,0-.85-.25c-.52,0-.75.2-.75.48,0,.78,1.87.19,1.87,1.3,0,.5-.44.82-1.19.82A1.9,1.9,0,0,1,243.78,228Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251,225.4,250,228.28h-.37l-.91-2.36-.91,2.36h-.37l-1.08-2.88h.37l.9,2.45.93-2.45h.33l.92,2.45.92-2.45Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M251.25,226.84a1.47,1.47,0,1,1,1.47,1.47A1.42,1.42,0,0,1,251.25,226.84Zm2.54,0a1.07,1.07,0,1,0-1.07,1.12A1.05,1.05,0,0,0,253.79,226.84Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M256.43,225.38v.38h-.09a.93.93,0,0,0-1,1.06v1.47H255V225.4h.37V226A1.09,1.09,0,0,1,256.43,225.38Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259.74,224.22v4.06h-.38v-.57a1.23,1.23,0,0,1-1.11.6,1.47,1.47,0,0,1,0-2.93,1.27,1.27,0,0,1,1.1.57v-1.73Zm-.39,2.62a1.07,1.07,0,1,0-1.07,1.12A1.05,1.05,0,0,0,259.35,226.84Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M262.57,225.43c0-.4-.32-.67-.88-.67a1.27,1.27,0,0,0-1.05.44l-.29-.22a1.69,1.69,0,0,1,1.37-.57c.76,0,1.26.37,1.26,1,0,.93-1,1-1,1.76h-.4C261.57,226.23,262.57,226.14,262.57,225.43ZM261.49,228a.29.29,0,0,1,.57,0,.29.29,0,1,1-.57,0Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 320.23,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.83,334l.41-.86a3.91,3.91,0,0,0,2.53.89c1.32,0,1.89-.51,1.89-1.18,0-1.87-4.64-.69-4.64-3.54,0-1.18.92-2.19,2.93-2.19a4.52,4.52,0,0,1,2.47.68l-.36.87a4,4,0,0,0-2.11-.62c-1.3,0-1.86.55-1.86,1.22,0,1.87,4.65.7,4.65,3.51,0,1.18-1,2.18-3,2.18A4.54,4.54,0,0,1,242.83,334Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,332.36H250.7a2,2,0,0,0,2.11,1.7,2.18,2.18,0,0,0,1.67-.7l.58.68a3.16,3.16,0,0,1-5.41-2,2.85,2.85,0,0,1,2.91-3,2.8,2.8,0,0,1,2.87,3C255.43,332.13,255.42,332.26,255.41,332.36Zm-4.71-.75h3.73a1.88,1.88,0,0,0-3.73,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.16,334.58a2,2,0,0,1-1.27.4,1.66,1.66,0,0,1-1.84-1.82V330h-1v-.86h1v-1.27h1.05v1.27h1.67V330H258.1v3.15a.85.85,0,0,0,.91,1,1.28,1.28,0,0,0,.82-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.73,329.92c0,1.67-1.21,2.67-3.2,2.67h-1.9v2.33h-1.09v-7.67h3C269.52,327.25,270.73,328.25,270.73,329.92Zm-1.1,0c0-1.1-.73-1.72-2.13-1.72h-1.87v3.44h1.87C268.9,331.64,269.63,331,269.63,329.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.74,331.41v3.51h-1v-.77a2.17,2.17,0,0,1-1.91.83c-1.31,0-2.14-.7-2.14-1.71s.6-1.7,2.33-1.7h1.67v-.2c0-.89-.52-1.41-1.56-1.41a3,3,0,0,0-1.84.63l-.44-.79a3.88,3.88,0,0,1,2.4-.75C275.84,329.05,276.74,329.82,276.74,331.41Zm-1.05,1.73v-.81h-1.63c-1,0-1.33.41-1.33.9s.48.94,1.28.94A1.69,1.69,0,0,0,275.69,333.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,334.3l.44-.83a3.72,3.72,0,0,0,2,.6c1,0,1.38-.29,1.38-.79,0-1.3-3.67-.17-3.67-2.48,0-1,.93-1.75,2.42-1.75a4.21,4.21,0,0,1,2.12.53l-.45.83a3,3,0,0,0-1.68-.46c-.92,0-1.37.34-1.37.8,0,1.37,3.69.25,3.69,2.51,0,1.05-1,1.72-2.51,1.72A4.13,4.13,0,0,1,278,334.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.45,334.3l.44-.83a3.72,3.72,0,0,0,2,.6c1,0,1.38-.29,1.38-.79,0-1.3-3.67-.17-3.67-2.48,0-1,.93-1.75,2.42-1.75a4.2,4.2,0,0,1,2.11.53l-.45.83a3,3,0,0,0-1.67-.46c-.92,0-1.37.34-1.37.8,0,1.37,3.68.25,3.68,2.51,0,1.05-1,1.72-2.51,1.72A4.15,4.15,0,0,1,283.45,334.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.35,329.11l-2.17,5.81h-1l-1.68-4.41-1.7,4.41h-1l-2.15-5.81h1l1.69,4.62,1.75-4.62H294l1.72,4.64,1.73-4.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.72,332a3,3,0,1,1,3,3A2.89,2.89,0,0,1,298.72,332Zm5,0a2,2,0,1,0-1.95,2.05A1.91,1.91,0,0,0,303.7,332Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.34,329.05v1h-.24a1.73,1.73,0,0,0-1.83,2v2.9h-1v-5.81h1v1A2.22,2.22,0,0,1,309.34,329.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.06,326.79v8.13h-1V334a2.46,2.46,0,0,1-2.07,1,3,3,0,0,1,0-5.93,2.47,2.47,0,0,1,2,.94v-3.2ZM315,332a2,2,0,1,0-1.95,2.05A1.91,1.91,0,0,0,315,332Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.41,168.17l-1.81-2.58c-.17,0-.35,0-.53,0H234v2.55h-1.2v-8.4h3.27c2.18,0,3.5,1.11,3.5,2.93a2.65,2.65,0,0,1-1.84,2.65l2,2.82Zm0-5.47c0-1.2-.8-1.88-2.34-1.88h-2v3.78h2C237.57,164.6,238.37,163.9,238.37,162.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.07,165.38h-5.15a2.14,2.14,0,0,0,2.3,1.85,2.37,2.37,0,0,0,1.83-.76l.64.74a3.46,3.46,0,0,1-5.92-2.22,3.11,3.11,0,0,1,3.19-3.24A3.07,3.07,0,0,1,247.1,165,2.26,2.26,0,0,1,247.07,165.38Zm-5.15-.83H246a2,2,0,0,0-4.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.89,167.5l.48-.91a4.13,4.13,0,0,0,2.23.66c1.07,0,1.51-.33,1.51-.87,0-1.42-4-.19-4-2.72,0-1.14,1-1.91,2.65-1.91a4.62,4.62,0,0,1,2.31.58l-.49.91a3.33,3.33,0,0,0-1.83-.5c-1,0-1.5.37-1.5.87,0,1.5,4,.28,4,2.75,0,1.15-1.06,1.88-2.75,1.88A4.59,4.59,0,0,1,247.89,167.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43,165.38h-5.16a2.16,2.16,0,0,0,2.3,1.85,2.39,2.39,0,0,0,1.84-.76l.64.74a3.22,3.22,0,0,1-2.51,1,3.18,3.18,0,0,1-3.42-3.25,3.12,3.12,0,0,1,3.19-3.24,3.06,3.06,0,0,1,3.14,3.28C260.45,165.12,260.44,165.27,260.43,165.38Zm-5.16-.83h4.08a2.05,2.05,0,0,0-4.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.63,167.8a2.18,2.18,0,0,1-1.39.44,1.82,1.82,0,0,1-2-2v-3.49h-1.08v-.95h1.08v-1.39h1.15v1.39h1.82v.95h-1.82v3.44a.94.94,0,0,0,1,1.07,1.48,1.48,0,0,0,.9-.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.19,162.7c0,1.82-1.32,2.93-3.5,2.93h-2.07v2.54h-1.2v-8.4h3.27C275.87,159.77,277.19,160.88,277.19,162.7Zm-1.2,0c0-1.2-.8-1.88-2.34-1.88h-2v3.76h2C275.19,164.58,276,163.9,276,162.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.77,164.33v3.84h-1.09v-.84a2.36,2.36,0,0,1-2.09.91c-1.44,0-2.35-.77-2.35-1.87s.66-1.86,2.55-1.86h1.83v-.23c0-1-.57-1.53-1.71-1.53a3.2,3.2,0,0,0-2,.68l-.48-.86a4.23,4.23,0,0,1,2.63-.82C282.79,161.75,283.77,162.59,283.77,164.33Zm-1.15,1.9v-.89h-1.78c-1.14,0-1.46.44-1.46,1s.53,1,1.4,1A1.84,1.84,0,0,0,282.62,166.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.1,167.5l.48-.91a4.13,4.13,0,0,0,2.23.66c1.07,0,1.52-.33,1.52-.87,0-1.42-4-.19-4-2.72,0-1.14,1-1.91,2.65-1.91a4.59,4.59,0,0,1,2.31.58l-.49.91a3.31,3.31,0,0,0-1.83-.5c-1,0-1.5.37-1.5.87,0,1.5,4,.28,4,2.75,0,1.15-1.06,1.88-2.75,1.88A4.62,4.62,0,0,1,285.1,167.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.12,167.5l.48-.91a4.11,4.11,0,0,0,2.23.66c1.06,0,1.51-.33,1.51-.87,0-1.42-4-.19-4-2.72,0-1.14,1-1.91,2.65-1.91a4.66,4.66,0,0,1,2.32.58l-.5.91a3.31,3.31,0,0,0-1.83-.5c-1,0-1.5.37-1.5.87,0,1.5,4,.28,4,2.75,0,1.15-1.06,1.88-2.75,1.88A4.56,4.56,0,0,1,291.12,167.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43,161.81l-2.37,6.36H304l-1.83-4.82-1.86,4.82h-1.11l-2.36-6.36h1.09l1.85,5.07,1.92-5.07h1l1.88,5.09,1.9-5.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.83,165a3.31,3.31,0,1,1,3.31,3.25A3.17,3.17,0,0,1,307.83,165Zm5.45,0a2.14,2.14,0,1,0-2.14,2.24A2.09,2.09,0,0,0,313.28,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.46,161.75v1.12h-.27a1.89,1.89,0,0,0-2,2.14v3.17H316v-6.36h1.1v1.07A2.44,2.44,0,0,1,319.46,161.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.81,159.27v8.9h-1.1v-1a2.69,2.69,0,0,1-2.27,1.08,3.25,3.25,0,0,1,0-6.49,2.72,2.72,0,0,1,2.22,1v-3.5ZM325.67,165a2.14,2.14,0,1,0-2.13,2.24A2.09,2.09,0,0,0,325.67,165Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 244.16,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.83,251.71v6.42h-.56l-4.13-5.21v5.21h-.68v-6.42H222l4.14,5.21v-5.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,255.92h-4a1.78,1.78,0,0,0,1.9,1.68,1.89,1.89,0,0,0,1.47-.63l.37.42a2.55,2.55,0,0,1-4.39-1.67,2.32,2.32,0,0,1,2.35-2.45,2.3,2.3,0,0,1,2.34,2.45C233,255.78,233,255.85,233,255.92Zm-4-.48h3.42a1.71,1.71,0,0,0-3.42,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.31,253.31l-1.82,4.82h-.62l-1.52-3.95-1.52,3.95h-.62l-1.81-4.82H234l1.51,4.1,1.55-4.1h.56l1.54,4.1,1.53-4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.86,253.91c0,1.37-1,2.2-2.62,2.2h-1.73v2h-.68v-6.42h2.41C248.87,251.71,249.86,252.54,249.86,253.91Zm-.68,0c0-1-.68-1.61-2-1.61h-1.71v3.21h1.71C248.5,255.51,249.18,254.92,249.18,253.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.78,255.14v3h-.62v-.75a1.8,1.8,0,0,1-1.66.8c-1.09,0-1.76-.57-1.76-1.4s.48-1.37,1.86-1.37h1.53v-.29a1.18,1.18,0,0,0-1.36-1.28,2.44,2.44,0,0,0-1.61.57l-.29-.49a3.06,3.06,0,0,1,2-.65A1.71,1.71,0,0,1,254.78,255.14Zm-.65,1.54v-.79h-1.51c-.94,0-1.24.37-1.24.87s.45.91,1.22.91A1.54,1.54,0,0,0,254.13,256.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.88,257.58l.3-.51a2.9,2.9,0,0,0,1.71.54c.92,0,1.3-.31,1.3-.79,0-1.26-3.13-.26-3.13-2.17,0-.79.68-1.38,1.91-1.38a3.3,3.3,0,0,1,1.7.45l-.28.52a2.52,2.52,0,0,0-1.42-.41c-.88,0-1.26.34-1.26.8,0,1.3,3.13.32,3.13,2.17,0,.84-.74,1.38-2,1.38A3.25,3.25,0,0,1,255.88,257.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.37,257.58l.29-.51a3,3,0,0,0,1.72.54c.91,0,1.29-.31,1.29-.79,0-1.26-3.13-.26-3.13-2.17,0-.79.68-1.38,1.91-1.38a3.36,3.36,0,0,1,1.71.45l-.29.52a2.48,2.48,0,0,0-1.42-.41c-.87,0-1.26.34-1.26.8,0,1.3,3.13.32,3.13,2.17,0,.84-.73,1.38-2,1.38A3.2,3.2,0,0,1,260.37,257.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.51,253.31l-1.82,4.82h-.62l-1.52-3.95L267,258.13h-.62l-1.81-4.82h.62l1.51,4.1,1.55-4.1h.56l1.54,4.1,1.53-4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.87,255.72a2.45,2.45,0,1,1,2.46,2.46A2.37,2.37,0,0,1,272.87,255.72Zm4.24,0a1.79,1.79,0,1,0-1.78,1.88A1.76,1.76,0,0,0,277.11,255.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.54,253.27v.64h-.16a1.55,1.55,0,0,0-1.62,1.77v2.46h-.66v-4.82h.63v.94A1.82,1.82,0,0,1,281.54,253.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.06,251.33v6.8h-.62v-.95a2.08,2.08,0,0,1-1.86,1,2.46,2.46,0,0,1,0-4.91,2.09,2.09,0,0,1,1.83,1v-2.9Zm-.64,4.39a1.79,1.79,0,1,0-1.79,1.88A1.76,1.76,0,0,0,286.42,255.72Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.3,
    y: 193.55,
    width: 130.84,
    height: 22.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.9,204.31a3.37,3.37,0,1,1,3.37,3.26A3.23,3.23,0,0,1,220.9,204.31Zm6.06,0a2.7,2.7,0,1,0-2.69,2.66A2.6,2.6,0,0,0,227,204.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,200.71h.65v6.81H229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.89,200.71v6.81h-.62v-1a2.1,2.1,0,0,1-1.86,1,2.45,2.45,0,0,1,0-4.9,2.1,2.1,0,0,1,1.83,1v-2.9Zm-.64,4.39a1.8,1.8,0,1,0-1.79,1.88A1.77,1.77,0,0,0,235.25,205.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.27,203.3c0,1.36-1,2.19-2.62,2.19h-1.72v2h-.68V201.1h2.4C244.28,201.1,245.27,201.92,245.27,203.3Zm-.68,0c0-1-.68-1.62-2-1.62h-1.7v3.21h1.7C243.91,204.89,244.59,204.31,244.59,203.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2,204.53v3h-.63v-.76a1.8,1.8,0,0,1-1.66.8c-1.09,0-1.76-.57-1.76-1.4s.48-1.37,1.86-1.37h1.54v-.29c0-.83-.47-1.28-1.37-1.28a2.48,2.48,0,0,0-1.61.57l-.29-.48a3,3,0,0,1,2-.65A1.72,1.72,0,0,1,250.2,204.53Zm-.65,1.54v-.79H248c-.93,0-1.24.37-1.24.86s.45.91,1.22.91A1.55,1.55,0,0,0,249.55,206.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,207l.29-.52a2.89,2.89,0,0,0,1.72.54c.91,0,1.29-.31,1.29-.78,0-1.26-3.13-.27-3.13-2.18,0-.79.68-1.37,1.91-1.37a3.27,3.27,0,0,1,1.71.45l-.29.52a2.48,2.48,0,0,0-1.42-.41c-.87,0-1.26.33-1.26.79,0,1.31,3.13.32,3.13,2.18,0,.83-.73,1.37-2,1.37A3.2,3.2,0,0,1,251.3,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.78,207l.3-.52a2.83,2.83,0,0,0,1.71.54c.92,0,1.29-.31,1.29-.78,0-1.26-3.12-.27-3.12-2.18,0-.79.68-1.37,1.9-1.37a3.21,3.21,0,0,1,1.71.45l-.28.52a2.53,2.53,0,0,0-1.43-.41c-.87,0-1.25.33-1.25.79,0,1.31,3.13.32,3.13,2.18,0,.83-.74,1.37-2,1.37A3.25,3.25,0,0,1,255.78,207Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.92,202.69l-1.82,4.83h-.61l-1.53-4-1.52,4h-.61L260,202.69h.62l1.52,4.1,1.55-4.1h.56l1.54,4.1,1.53-4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28,205.1a2.46,2.46,0,1,1,2.46,2.46A2.37,2.37,0,0,1,268.28,205.1Zm4.25,0a1.8,1.8,0,1,0-1.79,1.88A1.76,1.76,0,0,0,272.53,205.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,202.66v.63h-.16a1.56,1.56,0,0,0-1.62,1.78v2.46h-.65v-4.83h.62v.95A1.83,1.83,0,0,1,277,202.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.48,200.71v6.81h-.62v-1a2.11,2.11,0,0,1-1.87,1,2.45,2.45,0,0,1,0-4.9,2.13,2.13,0,0,1,1.84,1v-2.9Zm-.64,4.39a1.8,1.8,0,1,0-1.79,1.88A1.77,1.77,0,0,0,281.84,205.1Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.56,376.19s-6.18.82-8.82,0-1.65-12.8-4.34-13.05c-6.21-.57-5.15,15.34-2.51,18.69s16.23,1.93,16.23,1.93Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.56,376.19s-6.18.82-8.82,0-1.65-12.8-4.34-13.05c-6.21-.57-5.15,15.34-2.51,18.69s16.23,1.93,16.23,1.93Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.07,404.4s-9.15-81.24,1.77-82.17,13.56,27.71,9.34,81.14Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.07,404.4s-9.15-81.24,1.77-82.17,13.56,27.71,9.34,81.14Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.24 394.57 422.17 394.57 419.17 417.55 389.24 417.55 386.24 394.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.92,348.86s10,.53,10.25,0,.3-12,4.52-11.35,2.37,14.52,0,16.13-14.77,2.48-14.77,2.48S408.26,351,409.92,348.86Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.92,348.86s10,.53,10.25,0,.3-12,4.52-11.35,2.37,14.52,0,16.13-14.77,2.48-14.77,2.48S408.26,351,409.92,348.86Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.61,397c-2.21-21.67-4.61-43.45-4.06-65.26.16-1.67.27-9.85,3.05-8.6a2.66,2.66,0,0,1,.79,1.12,35.1,35.1,0,0,1,1.6,8.11c2.1,21.72,1.94,43.58,1.83,65.37-.41-21.77-.44-43.61-2.57-65.28-.28-2.65-1.88-14.28-3.51-5.29a95.13,95.13,0,0,0-.59,13.92c.37,18.67,1.88,37.3,3.46,55.91Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.17,351.59c2.92-.28,8.12-.46,10.62-1.11,0-3.43,1.21-8.09,2.44-11.74-.35,1.63-.69,4-1,5.71a41.88,41.88,0,0,0-.72,6.24c-.16.49-.77.58-1.16.68a45.27,45.27,0,0,1-10.21.22Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.17,354.24c4.17-.77,8.82-1.07,12.91-2.05,1.06-1.68,1-4.05,1.3-6,.24-2.18.42-4.37.63-6.56a63.37,63.37,0,0,1,0,6.61,21.86,21.86,0,0,1-.9,5.8,1.6,1.6,0,0,1-.67.86,71.63,71.63,0,0,1-13.24,1.34Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.48,378.41c-2.88.06-5.86.2-8.65-.76a3.65,3.65,0,0,1-1.22-2.36,28.69,28.69,0,0,1-.54-5.52,48.24,48.24,0,0,1,.19-5.51c.14,1.83.25,3.66.41,5.48a43.23,43.23,0,0,0,.7,5.38c.21.82.41,1.85,1.08,2a48.91,48.91,0,0,0,8,1.31Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.42,365.71l.65,6.39c.4,2.79.33,5.83,1.44,8.41a2.45,2.45,0,0,0,.57.32c3,1,6.27,1.07,9.4,1.44a44.71,44.71,0,0,1-6.44-.13c-1.48-.25-4-.2-4.51-2-1.24-4.71-1.17-9.64-1.11-14.47Z",
    style: {
      fill: "#5039CA"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361,139.57a23.65,23.65,0,0,1,32.25-8.76l-1,1.69,6.7-1.82-1.82-6.7-1,1.68a29.56,29.56,0,0,0-36.92,45.14l4.46-3.91A23.62,23.62,0,0,1,361,139.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,132.19,399.5,136a23.63,23.63,0,0,1-29.77,35.79l1-1.69L364,172l1.82,6.7,1-1.69A29.57,29.57,0,0,0,404,132.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361,139.57a23.65,23.65,0,0,1,32.25-8.76l-1,1.69,6.7-1.82-1.82-6.7-1,1.68a29.56,29.56,0,0,0-36.92,45.14l4.46-3.91A23.62,23.62,0,0,1,361,139.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,132.19,399.5,136a23.63,23.63,0,0,1-29.77,35.79l1-1.69L364,172l1.82,6.7,1-1.69A29.57,29.57,0,0,0,404,132.19Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Padlock--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.22,123.29H370.7v-20a13.87,13.87,0,0,0-27.74,0v20h-6.52v-20a20.39,20.39,0,0,1,40.78,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.22,123.29H370.7v-20a13.87,13.87,0,0,0-27.74,0v20h-6.52v-20a20.39,20.39,0,0,1,40.78,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.69,118.2v32.73a3.8,3.8,0,0,1-3.8,3.8H332.75a3.79,3.79,0,0,1-3.78-3.8V118.2a3.79,3.79,0,0,1,3.78-3.8h48.14a3.65,3.65,0,0,1,1.8.46A3.77,3.77,0,0,1,384.69,118.2Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,114.86v32.07a3.79,3.79,0,0,1-3.8,3.79H330.75a3.7,3.7,0,0,1-1.78-.45V118.2a3.79,3.79,0,0,1,3.78-3.8h48.14A3.65,3.65,0,0,1,382.69,114.86Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,130.46a7.17,7.17,0,1,0-9.67,6.82L354,146h5.73l-.85-8.55A7.27,7.27,0,0,0,364,130.46Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "127.37 139.57 130.69 150.24 134 139.57 127.37 139.57",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.95,
    y: 114.08,
    width: 71.47,
    height: 28.75,
    rx: 8.59,
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.75,128.44l1.88,1.06-.49.86-1.91-1.12,0,2.15h-1v-2.15l-1.91,1.12-.49-.86,1.9-1.06-1.9-1,.49-.88,1.91,1.12V125.5h1l0,2.13,1.91-1.12.49.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.39,128.44l1.88,1.06-.49.86-1.91-1.12v2.15h-.94v-2.15L115,130.36l-.49-.86,1.9-1.06-1.9-1,.49-.88,1.91,1.12V125.5h.94v2.13l1.91-1.12.49.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,128.44l1.88,1.06-.49.86-1.91-1.12v2.15h-1l0-2.15-1.91,1.12-.49-.86,1.89-1.06-1.89-1,.49-.88,1.91,1.12,0-2.13h1v2.13l1.91-1.12.49.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.67,128.44l1.88,1.06-.49.86-1.91-1.12v2.15h-.95l0-2.15-1.91,1.12-.49-.86,1.89-1.06-1.89-1,.49-.88,1.91,1.12,0-2.13h.95v2.13l1.91-1.12.49.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.31,128.44l1.88,1.06-.49.86-1.92-1.12,0,2.15h-1l0-2.15L135,130.36l-.5-.86,1.9-1.06-1.9-1,.5-.88,1.91,1.12,0-2.13h1l0,2.13,1.92-1.12.49.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94,128.44l1.89,1.06-.49.86-1.92-1.12,0,2.15h-.95l0-2.15-1.92,1.12-.49-.86,1.9-1.06-1.9-1,.49-.88,1.92,1.12,0-2.13h.95l0,2.13,1.92-1.12.49.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.58,128.44l1.88,1.06-.49.86-1.91-1.12,0,2.15h-1v-2.15l-1.91,1.12-.49-.86,1.9-1.06-1.9-1,.49-.88,1.91,1.12V125.5h1l0,2.13,1.91-1.12.49.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.07,214.07l6.1-3.95-6.87-4.22s-5.23,3.85-3.13,6.46Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.3 203.63 176.16 202.01 173.3 205.9 180.17 210.12 183.3 203.63",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,201.25c3.86,5.84,7.73,12.94,13,17.49.1.08.06,0-.33,0-.2.05-.1.15.31,0a10.69,10.69,0,0,0,3.11-2.68,51.65,51.65,0,0,0,5.2-7.59c.07-.11,0,0,0,.12a2,2,0,0,0,0,.55c.09.09-.23-.17.39,1.2a2.66,2.66,0,0,0,2.73,1.13,2.44,2.44,0,0,0,1.59-1.15s0,0,0,0a4.3,4.3,0,0,0-.42.59L170.1,209a4,4,0,0,1,.76-1.75,2.66,2.66,0,0,1,1.37-.82,2.69,2.69,0,0,1,2.75,1.14c.62,1.38.31,1.12.4,1.22a3.69,3.69,0,0,1-.09.95c-1.57,6.67-5.67,17.66-14.17,17.72-6-.55-10.55-7.14-13.92-11.3a103.24,103.24,0,0,1-6.6-10l8.35-4.9Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.92,196.86c4,1.32,12.11,19.75,12.11,19.75l-13.78,6.54S141.45,208.67,142,204A11,11,0,0,1,145.92,196.86Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.92,196.86c4,1.32,12.11,19.75,12.11,19.75l-13.78,6.54S141.45,208.67,142,204A11,11,0,0,1,145.92,196.86Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.12 410.53 155.1 412.52 153.43 401.59 152.53 395.75 159.55 393.76 160.75 401.59 162.12 410.53",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.76 411.1 114.52 412.06 114.45 401.59 114.4 395.08 121.65 394.14 121.7 401.59 121.76 411.1",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.65 394.14 121.7 401.59 114.45 401.59 114.4 395.08 121.65 394.14",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.75 401.59 153.43 401.59 152.53 395.75 159.55 393.76 160.75 401.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,409.43l-8-.21a.64.64,0,0,0-.64.48l-1.67,6.42a1,1,0,0,0,1,1.32c2.88,0,7,0,10.65.07,4.23.12,6.92-.09,11.88,0,3,.08,3.93-2.91,2.69-3.22-5.67-1.4-9.37-1.12-14.2-4.28A3.34,3.34,0,0,0,162,409.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.61,410.32a.17.17,0,0,1,.09-.18c.34-.16,3.33-1.57,4.2-1.05a.54.54,0,0,1,.27.47,1,1,0,0,1-.36.83c-.82.68-2.9.34-4.07.07h0A.16.16,0,0,1,162.61,410.32Zm.71-.08c1.61.31,2.81.27,3.27-.12a.6.6,0,0,0,.23-.54.2.2,0,0,0-.1-.19l-.06,0C166.11,409.16,164.5,409.72,163.32,410.24Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.67,410.43a.14.14,0,0,1-.06-.15,4.87,4.87,0,0,1,1.23-2.77,1.24,1.24,0,0,1,1-.27c.47.06.6.3.63.5.1.82-1.7,2.35-2.6,2.72a.24.24,0,0,1-.12,0Zm2.09-2.85a.93.93,0,0,0-.71.2,4,4,0,0,0-1,2.21c.92-.51,2.15-1.71,2.08-2.21,0,0,0-.11-.15-.16Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.47,409.43l-8-.21a.64.64,0,0,0-.64.48l-1.68,6.42a1.05,1.05,0,0,0,1,1.32c2.87,0,7,0,10.65.07,4.23.12,6.91-.09,11.87,0,3,.08,3.94-2.91,2.69-3.22-5.66-1.4-9.37-1.12-14.19-4.28A3.37,3.37,0,0,0,121.47,409.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,410.32a.17.17,0,0,1,.1-.18c.34-.16,3.32-1.57,4.19-1.05a.54.54,0,0,1,.27.47,1,1,0,0,1-.35.83c-.83.68-2.91.34-4.08.07h0A.18.18,0,0,1,122,410.32Zm.72-.08c1.6.31,2.81.27,3.27-.12a.62.62,0,0,0,.23-.54.22.22,0,0,0-.11-.19l-.06,0C125.55,409.16,123.94,409.72,122.76,410.24Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11,410.43a.15.15,0,0,1-.07-.15,4.9,4.9,0,0,1,1.24-2.77,1.23,1.23,0,0,1,1-.27c.47.06.6.3.62.5.11.82-1.7,2.35-2.59,2.72a.29.29,0,0,1-.13,0Zm2.09-2.85a.92.92,0,0,0-.71.2,4.08,4.08,0,0,0-1,2.21c.92-.51,2.15-1.71,2.09-2.21a.21.21,0,0,0-.16-.16A.61.61,0,0,0,124.2,407.58Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.83,252c-3.84,16.62,2.74,147.39,2.74,147.39h12.72l5.44-109,20,109,13.6-1c-8.89-84.42-16.74-134.82-16.74-134.82v-6.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.35,398.37l-13.6,1L132,313.57l-4.26-23.19-5.44,109H109.58S103,268.59,106.83,252l37.8,5.21,0,6.37S152.46,314,161.35,398.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,195.79a160.19,160.19,0,0,1,2.23,23.74c.13,5.55,0,10.83-.19,15.61-.5,11.21-1.58,19.69-1.53,22.6l38.16.68c9.1-39.9,1.28-61.56,1.28-61.56a75.92,75.92,0,0,0-9-1.92q-1-.13-2-.24a141.37,141.37,0,0,0-16.22-.3c-1,0-2.07.09-3.08.17C110.55,195,106,195.79,106,195.79Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.19,196s-2.27,3.29-4.09,3.52c-2.58.35-12-5.42-12-5.42,2.18-1.61,3.25-5.12,3.72-8.83a50.34,50.34,0,0,0,.19-9.07l8.81,9.58c-1.16,3-1.85,6.2.43,8.45h0A7.88,7.88,0,0,0,136.19,196Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.23,194.2a25.11,25.11,0,0,1-9.43-9,50.34,50.34,0,0,0,.19-9.07l8.81,9.58C131.64,188.74,131,192,133.23,194.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,167.56c.75,2.77,0,8.39-3.72,6.39S141.75,162.78,143,167.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.12,170.41c-.73,7-1.51,11.1,1.42,15.23,4.42,6.2,13.57,4.35,16.38-2.34,2.54-6,3.3-16.5-3.07-20.34A9.75,9.75,0,0,0,123.12,170.41Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.22,166.79l.35-7.87s-8.36-1-8.17,3.32c-4.74,2.1-2.86,9.41,3.22,13.22,3.54-2.58,3.43-9.19,3.43-9.19C127.41,166.45,127.81,166.62,128.22,166.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.47,175.76a6.63,6.63,0,0,0,2.64,4.38c1.9,1.38,3.69-.14,3.85-2.36.15-2-.66-5.13-2.9-5.63A3.06,3.06,0,0,0,119.47,175.76Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.39,174c-.1.57.13,1.07.5,1.13s.75-.35.84-.92-.13-1.07-.5-1.13S133.48,173.43,133.39,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,175c-.09.57.14,1.08.51,1.13s.75-.35.84-.92-.13-1.07-.5-1.13S139.91,174.44,139.81,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.72,175a20,20,0,0,0,2,5.1,3.42,3.42,0,0,1-2.78,0Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.53,181.8a4.89,4.89,0,0,0,.73.17.17.17,0,0,0,.19-.14.17.17,0,0,0-.14-.2,4.54,4.54,0,0,1-3.38-2.32.16.16,0,0,0-.22-.09.17.17,0,0,0-.09.22A4.71,4.71,0,0,0,133.53,181.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.75,171.62a.32.32,0,0,0,.33-.08,2.76,2.76,0,0,1,2.33-.78.33.33,0,1,0,.15-.65,3.34,3.34,0,0,0-2.94.95.34.34,0,0,0,0,.48A.37.37,0,0,0,131.75,171.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,173.23a.31.31,0,0,0,.19,0,.34.34,0,0,0,.23-.42,3.31,3.31,0,0,0-2.09-2.25.35.35,0,0,0-.42.23.34.34,0,0,0,.23.42,2.55,2.55,0,0,1,1.63,1.8A.34.34,0,0,0,143,173.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,162.24s-4.32-4.29,10.34-3.9,17.1,8.61,10.38,10.52l-.3-1.34a9.12,9.12,0,0,1-7.52.38l1.06-.66S124.35,168.26,120.4,162.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,199.49s-1.87,2.16-4,4.29c-3.11-1.57-10.39-5.78-10-9.67.43-1.13,3.39-1.85,3.39-1.85S124.63,196.45,132.1,199.49Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,199.49a20.73,20.73,0,0,1,4,4.29c2.29-1.48,1.14-8.72.3-9.52a8.17,8.17,0,0,0-3.95-1A6.68,6.68,0,0,1,132.1,199.49Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.1,199.49s-1.87,2.16-4,4.29c-3.11-1.57-10.39-5.78-10-9.67.43-1.13,3.39-1.85,3.39-1.85S124.63,196.45,132.1,199.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,199.49a20.73,20.73,0,0,1,4,4.29c2.29-1.48,1.14-8.72.3-9.52a8.17,8.17,0,0,0-3.95-1A6.68,6.68,0,0,1,132.1,199.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132,313.57l-4.26-23.19.82-12.27S134.39,299.39,132,313.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,206.38c-3.7,6.17-9.43,15-12.57,21.27-1.67,3.55-2.19,7.35-3.1,11.18-.87,4.09-1.74,8.26-2.7,12.38l-4.78-.42c-.17-4.33-.13-8.62.13-12.95.33-4.51.57-9.38,2.27-13.66,3.38-8.23,7.83-15.59,12.6-23l8.15,5.22Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,195.79c-5.37,1.39-15,20.69-15,20.69l11.41,7.39,10.29-10a24.73,24.73,0,0,0-.65-10.85C110.38,197,106,195.79,106,195.79Z",
    style: {
      fill: "#5039CA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,195.79c-5.37,1.39-15,20.69-15,20.69l11.41,7.39,10.29-10a24.73,24.73,0,0,0-.65-10.85C110.38,197,106,195.79,106,195.79Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58,209.63H211.12a4.74,4.74,0,0,1,4.74,4.74V217a4.74,4.74,0,0,1-4.74,4.74H95.58a0,0,0,0,1,0,0V209.63A0,0,0,0,1,95.58,209.63Z",
    transform: "translate(-108.04 181) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58,209.63H211.12a4.74,4.74,0,0,1,4.74,4.74V217a4.74,4.74,0,0,1-4.74,4.74H95.58a0,0,0,0,1,0,0V209.63A0,0,0,0,1,95.58,209.63Z",
    transform: "translate(-108.04 181) rotate(-46.68)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,171.59l1.33,1.25a4.73,4.73,0,0,1,.2,6.69L118.86,263.6l-1.32-1.25,79.27-84.07A4.73,4.73,0,0,0,196.6,171.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.31 204.14 186 218 187.91 215.97 186.01 214.18 189.03 210.97 187.92 209.92 192.46 205.11 193.57 206.16 196.41 203.15 198.31 204.95 200.28 202.85 199.17 201.8 202.01 198.78 199.78 196.68 201.64 194.71 204.99 197.86 208.39 194.26 193.7 180.4 171.31 204.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.31 204.14 186 218 187.91 215.97 186.01 214.18 189.03 210.97 187.92 209.92 192.46 205.11 193.57 206.16 196.41 203.15 198.31 204.95 200.28 202.85 199.17 201.8 202.01 198.78 199.78 196.68 201.64 194.71 204.99 197.86 208.39 194.26 193.7 180.4 171.31 204.14",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.91,
    y: 215.45,
    width: 2.78,
    height: 1.82,
    transform: "translate(-98.93 203.47) rotate(-46.68)",
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.57 206.16 192.46 205.1 187.92 209.92 189.03 210.97 186.01 214.18 184.68 212.93 187.71 209.72 186.59 208.67 191.13 203.85 192.25 204.91 195.08 201.9 196.41 203.15 193.57 206.16",
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.84 200.54 200.69 197.53 202.02 198.78 199.17 201.8 200.29 202.85 198.31 204.95 196.99 203.7 198.96 201.6 197.84 200.54",
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.69,
    y: 194.15,
    width: 2.71,
    height: 1.82,
    transform: "translate(-79.12 206.78) rotate(-46.68)",
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.55,
    y: 194.52,
    width: 4.96,
    height: 1.82,
    transform: "translate(-77.51 211.26) rotate(-46.68)",
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 161.47,
    y: 182.56,
    width: 37.54,
    height: 14.24,
    rx: 1.06,
    transform: "translate(-81.42 190.68) rotate(-46.68)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.32,290.77h0a20.47,20.47,0,0,1-28.94.85l-6.64-6.26a20.47,20.47,0,0,1-.85-28.94h0a20.48,20.48,0,0,1,29-.85l6.63,6.26A20.47,20.47,0,0,1,119.32,290.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.69,283.57h0a10.19,10.19,0,0,1-14.41.43L91,278a10.19,10.19,0,0,1-.42-14.41h0a10.17,10.17,0,0,1,14.4-.42l6.34,6A10.19,10.19,0,0,1,111.69,283.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.47,
    y: 182.56,
    width: 37.54,
    height: 14.24,
    rx: 1.06,
    transform: "translate(-81.42 190.68) rotate(-46.68)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.32,290.77h0a20.47,20.47,0,0,1-28.94.85l-6.64-6.26a20.47,20.47,0,0,1-.85-28.94h0a20.48,20.48,0,0,1,29-.85l6.63,6.26A20.47,20.47,0,0,1,119.32,290.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.69,283.57h0a10.19,10.19,0,0,1-14.41.43L91,278a10.19,10.19,0,0,1-.42-14.41h0a10.17,10.17,0,0,1,14.4-.42l6.34,6A10.19,10.19,0,0,1,111.69,283.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.87,177.68l2.66,2.5a1.06,1.06,0,0,1,0,1.51l-24.3,25.76a1.05,1.05,0,0,1-1.5,0l-2.65-2.5a1.06,1.06,0,0,0,1.49,0l24.3-25.77A1.05,1.05,0,0,0,194.87,177.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103,261.32l2,1.87A10.2,10.2,0,0,0,91,278l-2-1.88a10.19,10.19,0,0,1,14-14.83Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.49,260l2,1.88a20.48,20.48,0,0,1-28.1,29.79l-2-1.87a20.48,20.48,0,0,0,28.1-29.8Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103,261.32l2,1.87A10.2,10.2,0,0,0,91,278l-2-1.88a10.19,10.19,0,0,1,14-14.83Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103,261.32l2,1.87A10.2,10.2,0,0,0,91,278l-2-1.88a10.19,10.19,0,0,1,14-14.83Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "87.78 262.21 95.13 260.37 94.31 255 85.35 256.81 87.78 262.21",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.06,249.78l-1.71,7,9-1.81s.12-6.29-3.22-6.7Z",
    style: {
      fill: "#b55b52"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePassword);
export default __webpack_public_path__ + "static/media/UpdatePassword.650d02f413944305975fd5fbc203de8a.svg";
export { ForwardRef as ReactComponent };